<template>
  <v-card>
    <v-tabs vertical>
      <v-navigation-drawer permanent expand-on-hover @change="getChange">
        <v-tab class="tabs">
          <v-icon class="pr-4">mdi-checkbox-multiple-outline</v-icon>
          CARATTERISTICHE
        </v-tab>
        <v-tab
          v-show="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== ''
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-menu</v-icon> CATEGORIA
        </v-tab>
        <v-tab
          v-show="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== ''
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-script</v-icon>
          SPECIFICHE
        </v-tab>
        <v-tab
          v-show="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== ''
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-package-variant-closed</v-icon>
          PACKAGING
        </v-tab>
        <v-tab
          v-show="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== ''
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-assistant</v-icon> ASSOCIAZIONI
        </v-tab>
        <v-tab
          v-if="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== '' &&
            distinta_base_versione == 0
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-text</v-icon> DISTINTA BASE
        </v-tab>
        <v-tab
          v-if="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== '' &&
            distinta_base_versione == 1
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-format-list-text</v-icon> DISTINTA BASE ALT.
        </v-tab>
        <v-tab
          v-show="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== ''
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-circle-slice-5</v-icon> CICLO PRODUZIONE
        </v-tab>
        <v-tab
          v-show="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== ''
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-store</v-icon> MAGAZZINO
        </v-tab>
        <v-tab
          v-show="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== ''
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-view-carousel</v-icon> UTILIZZO
        </v-tab>
        <v-tab
          v-show="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== ''
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-cash</v-icon> COSTO
        </v-tab>
        <v-tab
          v-show="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== '' &&
            articolo_extra_allowed == 1
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-dolly</v-icon> ARTICOLO EXTRA
        </v-tab>
        <v-tab
          v-show="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== '' &&
            modulo_varianti == 1
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-dolly</v-icon> VARIANTI
        </v-tab>
        <v-tab
          v-show="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== ''
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-apache-kafka</v-icon> ARTICOLO ALTERNATIVO
        </v-tab>
        <v-tab
          v-show="
            data.id_articolo != null &&
            data.id_articolo > -1 &&
            data.id_articolo !== ''
          "
          class="tabs"
        >
          <v-icon class="pr-4">mdi-content-duplicate</v-icon> ARTICOLO RESIDUO
        </v-tab>
      </v-navigation-drawer>
      <v-tab-item
        style="height: 100px !important"
        :transition="false"
        :reverse-transition="false"
      >
        <v-card flat>
          <v-card-text
            class="px-0 py-0"
            style="overflow-y: auto; height: 100vh"
          >
            <Caratteristiche
              v-on:ValChanged="valChanged($event)"
              v-on:update="updateDrawer($event)"
              :CodEnable="this.CodEnable"
              :dataChar="this.data"
              :key="caratteristiche_key"
            />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card flat>
          <v-card-text class="px-0 py-0">
            <Categoria />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card flat>
          <v-card-text class="px-0 py-0">
            <Specifiche
              @update_id_report="handleUpdateIdReport"
              @update_scadenza="handleUpdateScadenza"
              @update_um_scadenza="handleUpdateUMScadenza"
              @update_prelievo_lotti_successivi="
                handleUpdatePrelievoLottiSuccessivi
              "
              @update_cod_prefisso_lotto="handleUpdateCodPrefissoLotto"
              @update_prefisso_lotto="handleUpdatePrefissoLotto"
              @update_barcode="handleUpdateBarcode"
              :data="this.data"
              ref="RefSpecifiche"
            />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card flat>
          <v-card-text class="px-0 py-0">
            <Packaging
              v-on:update="updatePackging($event)"
              :data="this.data"
              :conteCod="this.contentConte"
              :imballoCod="this.imballoCod"
              :quicklabel_allowed="quicklabel_allowed"
            />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card flat>
          <v-card-text class="px-0 py-0">
            <Associations :data="this.data" />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        :transition="false"
        :reverse-transition="false"
        v-if="
          data.id_articolo != null &&
          data.id_articolo > -1 &&
          data.id_articolo !== '' &&
          distinta_base_versione == 0
        "
      >
        <v-card flat>
          <v-card-text class="px-0 py-0">
            <BasicDistinct :pdata="this.data" />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        :transition="false"
        :reverse-transition="false"
        style="overflow-y: auto"
        v-if="
          data.id_articolo != null &&
          data.id_articolo > -1 &&
          data.id_articolo !== '' &&
          distinta_base_versione == 1
        "
      >
        <DistintaBaseAlt :articolo_sel="this.data" />
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card flat>
          <v-card-text class="px-0 py-0">
            <CicloProdList :data="this.data" />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <!--<v-tab-item  :transition="false" :reverse-transition="false">
        <v-card  flat>
            <v-card-text>
                <Commesse />
            </v-card-text>
        </v-card>
    </v-tab-item>-->
      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card flat>
          <v-card-text class="px-0 py-0">
            <Magazzino :articolo_sel="data" />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card flat>
          <v-card-text class="px-0 py-0">
            <Utilizzo :pdata="this.data" />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card flat>
          <v-card-text class="px-0 py-0">
            <Costo ref="articoloCosto" :data="data" />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        :transition="false"
        :reverse-transition="false"
        v-show="articolo_extra_allowed === 1"
      >
        <v-card flat>
          <v-card-text class="pb-0 pt-5 px-5">
            <ArticoloExtra :articolo_sel="this.data" />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        :transition="false"
        :reverse-transition="false"
        v-show="modulo_varianti === 1"
      >
        <v-card flat>
          <v-card-text class="pb-0 pt-5 px-5">
            <ArticoloVarianti :articolo_sel="this.data" @update_varianti="handleUpdateVarianti" />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card flat>
          <v-card-text class="pb-0 pt-5 px-5">
            <ArticoloAlternativo :articolo_prop="this.data" />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card flat>
          <v-card-text class="pb-0 pt-5 px-5">
            <ArticoloResiduo :articolo_prop="this.data" />
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import ArticoloExtra from "./ArticoloExtra";
import ArticoloVarianti from "./ArticoloVarianti";
import ArticoloAlternativo from "./ArticoloAlternativo";
import ArticoloResiduo from "./ArticoloResiduo";
import Caratteristiche from "./CaratteristicheNew";
import Categoria from "./Categoria";
import Specifiche from "./Specifiche";
import Packaging from "./Packaging2";
import Associations from "./AssociazioniDisegni";
import BasicDistinct from "./DistintaBase";
import DistintaBaseAlt from "./DistintaBaseAlt";
import Magazzino from "./Magazzino";
import Utilizzo from "./Utlizzo";
import Costo from "./Costo";
import CicloProdList from "../CicoloFasi/ArticoloCicloFasiNew.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  components: {
    ArticoloExtra,
    ArticoloVarianti,
    ArticoloAlternativo,
    ArticoloResiduo,
    Caratteristiche,
    Categoria,
    Specifiche,
    Packaging,
    Associations,
    BasicDistinct,
    DistintaBaseAlt,
    Magazzino,
    Utilizzo,
    Costo,
    CicloProdList,
    SnackbarQV,
  },
  props: ["data", "contentConte", "imballoCod", "CodEnable"],
  data() {
    return {
      // Variabili di supporto
      articolo_extra_allowed: 0,
      caratteristiche_key: 0,
      distinta_base_versione: 0,
      modulo_varianti: 0,
      overlay1: false,
      quicklabel_allowed: 0,

      // Array
      items: [],
    };
  },
  methods: {
    handleUpdateBarcode(arg) {
      this.$emit("update_barcode", arg);
    },
    handleUpdateIdReport(arg) {
      this.$emit("update_id_report", arg);
    },
    handleUpdateScadenza(arg) {
      this.$emit("update_scadenza", arg);
    },
    handleUpdateUMScadenza(arg) {
      this.$emit("update_um_scadenza", arg);
    },
    handleUpdateVarianti() {
      this.caratteristiche_key = this.caratteristiche_key == 0 ? 1 : 0;
    },
    handleUpdateCodPrefissoLotto(arg) {
      this.$emit("update_cod_prefisso_lotto", arg);
    },
    handleUpdatePrefissoLotto(arg) {
      this.$emit("update_prefisso_lotto", arg);
    },
    handleUpdatePrelievoLottiSuccessivi(arg) {
      this.$emit("update_prelievo_lotti_successivi", arg);
    },
    save() {
      if (typeof this.$refs.RefSpecifiche != "undefined") {
        this.$refs.RefSpecifiche.save();
      }
    },
    getModuliDrawer() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodulialternativi",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.result) {
              return;
            }

            // Se l'array di risposta è vuoto non faccio nulla
            if (!res.data.result.length > 0) {
              return;
            }

            // Se l'array contiene informazioni sulla distinta alternativa, le registro.
            if (
              res.data.result.filter(
                (e) => e.descrizione === "DISTINTA_ALTERNATIVA"
              ).length > 0
            ) {
              this.distinta_base_versione = res.data.result.filter(
                (e) => e.descrizione === "DISTINTA_ALTERNATIVA"
              )[0].val_int;
            }

            // Se l'array contiene informazioni sull'articolo extra, le registro.
            if (
              res.data.result.filter((e) => e.descrizione === "ARTICOLO_EXTRA")
                .length > 0
            ) {
              this.articolo_extra_allowed = res.data.result.filter(
                (e) => e.descrizione === "ARTICOLO_EXTRA"
              )[0].val_int;
            }

            // Se l'array contiene informazioni su QuickLabel, le registro.
            if (
              res.data.result.filter(
                (e) => e.descrizione === "MODULO_QUICKLABEL"
              ).length > 0
            ) {
              this.quicklabel_allowed = res.data.result.filter(
                (e) => e.descrizione === "MODULO_QUICKLABEL"
              )[0].val_int;
            }

            // Se l'array contiene informazioni sulle varianti, le registro.
            if (
              res.data.result.filter((e) => e.descrizione === "MODULO_VARIANTI")
                .length > 0
            ) {
              this.modulo_varianti = res.data.result.filter(
                (e) => e.descrizione === "MODULO_VARIANTI"
              )[0].val_int;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    valChanged(val) {
      this.$emit("valChanged", val);
    },
    updateDrawer(val) {
      this.$emit("updateDrawer", val);
    },
    updatePackging(val) {
      this.$emit("updatePackging", val);
    },
  },
  mounted() {
    this.getModuliDrawer();
  },
};
</script>
<style scoped>
.tabs {
  justify-content: start !important;
}
</style>
